export default {"src":"https://fishbrain.com/_next/static/media/earlyMorning.3d25e1d1.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};